import type { ReactElement } from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { cvProRegister, sendEvent } from '@/utils/gtag'
import { trackMxEvent } from '@/utils/mixpanel'
import useAuth from '@/hooks/useAuth'
import { Button } from '@/components/ui/button'

const RegisterProTopView = (): ReactElement | null => {
  const { currentUser, isLoggedin } = useAuth()
  const handleClick = () => {
    sendEvent({ event: 'to_register_pro_bio' })
    cvProRegister()
    trackMxEvent('Regipro Start Click')
  }
  return (
    <main className="container mb-28">
      <header className="mb-20 md:mb-28">
        <h1 className="mb-8 pt-12 text-center text-2xl font-medium leading-normal md:pt-20 md:text-3xl">
          クリエイターアカウント登録を始めましょう！
        </h1>
        <div className="mb-8 flex justify-center">
          <Image
            src="/images/register-pro/hero.png"
            alt=""
            width={320}
            height={320}
          />
        </div>
        <p className="text-sm font-medium !leading-loose text-black dark:text-white md:text-center md:text-base">
          より良い音楽制作には、経験によって培われたクリエイターなスキルと、人を感動させるセンスが不可欠です。
          <br />
          ONLIVE
          Studioでは、これまであなたが音楽に対してたくさんの愛情を注いできたからこそ得られた
          <br className="hidden md:block" />
          クリエイタースキルを様々な音楽制作に活かすことが出来ます。
          <br />
          より多くのプロジェクトに参加することで、より多くの人の感動メイクをしてみませんか？
        </p>
      </header>
      <section>
        <h2 className="mb-12 text-center text-2xl font-medium leading-normal md:text-3xl">
          これらを用意しておくと、登録がスムーズになります
        </h2>
        <ul className="mb-10 flex flex-wrap items-start justify-center lg:gap-x-20">
          <li className="shrink-1 w-1/2 lg:w-auto">
            <div className="flex justify-center">
              <div className="relative h-[120px] w-[120px] md:h-[160px] md:w-[160px]">
                <Image src="/images/register-pro/required-1.png" alt="" fill />
              </div>
            </div>
            <p className="text-center text-xs font-medium md:text-base">
              申請用のプロフィール
            </p>
          </li>
          <li className="shrink-1 w-1/2 lg:w-auto">
            <div className="flex justify-center">
              <div className="relative h-[120px] w-[120px] md:h-[160px] md:w-[160px]">
                <Image
                  src="/images/register-pro/required-2.png"
                  alt=""
                  width={160}
                  height={160}
                />
              </div>
            </div>
            <p className="text-center text-xs font-medium md:text-base">
              WebサイトやSNS
            </p>
          </li>
          <li className="shrink-1 w-1/2 lg:w-auto">
            <div className="flex justify-center">
              <div className="relative h-[120px] w-[120px] md:h-[160px] md:w-[160px]">
                <Image
                  src="/images/register-pro/required-3.png"
                  alt=""
                  width={160}
                  height={160}
                />
              </div>
            </div>
            <p className="text-center text-xs font-medium md:text-base">
              身分証明書
            </p>
          </li>
          <li className="shrink-1 w-1/2 lg:w-auto">
            <div className="flex justify-center">
              <div className="relative h-[120px] w-[120px] md:h-[160px] md:w-[160px]">
                <Image
                  src="/images/register-pro/required-4.png"
                  alt=""
                  width={160}
                  height={160}
                />
              </div>
            </div>
            <p className="text-center text-xs font-medium md:text-base">
              それなりのモチベーション
            </p>
          </li>
        </ul>
        <p className="mb-12 text-sm font-medium leading-loose md:mb-20 md:text-center md:text-base md:leading-loose">
          まず初めに、あなたの経歴、対応できる楽器やスキル、活動がわかるWebサイトやSNS、
          <br className="hidden md:block" />
          必要に応じて、これまでの実績のわかるWebサイトやSNSを入力していただきます。
          <br />
          次に、決済のやりとりに必要な個人情報を入力していただきます。
          <br />
          身分証明書が必要なため、お手元に顔写真付きの身分証明書をご用意ください。
        </p>
      </section>
      <p className="mb-12 text-center text-lg font-bold md:mb-20 md:text-xl">
        準備ができたら、早速登録してみましょう！
      </p>
      <div className="text-center">
        {isLoggedin && currentUser?.isProfessional ? (
          <Button asChild variant="primary" size="xl">
            <Link href="/my">
              <span>アカウント設定</span>
            </Link>
          </Button>
        ) : (
          <Button asChild variant="special" size="xl">
            <Link
              href={isLoggedin ? '/register-pro/bio' : '/signup?ref=pro'}
              onClick={handleClick}
            >
              <span>登録をはじめる</span>
            </Link>
          </Button>
        )}
      </div>
    </main>
  )
}

export default RegisterProTopView
